import { createSelector } from "reselect";

export const merchants = (state) => state.merchants;

export const merchantsSortedByName = createSelector(merchants, (merchants) =>
  merchants.sort((a, b) => {
    if (a["name"] > b["name"]) return 1;
    else if (a["name"] < b["name"]) return -1;
    else return 0;
  })
);

export const merchantsById = createSelector(merchants, (merchants) =>
  merchants.reduce((obj, merchant) => {
    obj[merchant.id] = merchant;
    return obj;
  }, [])
);

export const merchantValueSelector = createSelector(
  merchantsSortedByName,
  (merchants) =>
    merchants.map((merch) => ({
      value: merch.id,
      label: merch.name,
      ...merch,
    }))
);
